import React, { useState, useEffect } from "react";
import { string, bool } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import DfpAd from "../../dfp-ad";
import { refreshDfpAds } from "@quintype/components";

const TopAd = ({ className = "", lang, pageType, isTopAd, currentPath }) => {
  const [showTopAd, setShowTopAd] = useState(true);

  const getAdTypes = () => {
    if (lang === "en") {
      switch (pageType) {
        case "home-page":
          return "EnPalo_HP_970x90_T1";
        default:
          return "EnPalo_ROS_728x90_T1";
      }
    } else {
      switch (pageType) {
        case "home-page":
          return "Home_728x90_T1";
        default:
          return "News_728x90_T1";
      }
    }
  };

  useEffect(() => {
    setShowTopAd(true);

    if (
      window &&
      (window.location.href.includes("auth.prothomalo") || window.location.href.includes("auth.prothom-alo"))
    ) {
      setShowTopAd(false);
    } else if (
      window.location.pathname !== "/" &&
      currentPath !== window.location.pathname &&
      pageType !== "home-page" &&
      showTopAd
    ) {
      refreshDfpAds("header-ad");
    }
  });

  return isTopAd && pageType !== "story-page" ? (
    <div className={className}>{showTopAd && <DfpAd adtype={getAdTypes()} topAd={true} slotId="header-ad" />}</div>
  ) : null;
};

TopAd.propTypes = {
  adtype: string,
  className: string,
  lang: string,
  pageType: string,
  isTopAd: bool,
  currentPath: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
  pageType: get(state, ["qt", "pageType"]),
  isTopAd: get(state, ["topAdReducer", "isTopAd"], true),
  currentPath: get(state, ["qt", "currentPath"], ""),
});

export default connect(mapStateToProps, null)(TopAd);
